import { useState } from 'react';

import { SelectOption } from '@models/common/SelectOption';
import { CategoryService } from '@services/Category';

const initialCategories: SelectOption[] = [];

export const useCategorySelectOptions = () => {
  const [categorySelectOptions, setCategorySelectOptions] =
    useState<SelectOption[]>(initialCategories);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [errorMessages, setErrorMessages] = useState<string[] | undefined>([]);

  const loadData = async () => {
    setIsLoading(true);
    const result = await CategoryService.getCategorySelectOptions();

    if (result.isSuccess && 'data' in result) {
      const options = [
        { value: '0', text: '' },
        ...result.data.map((row) => ({
          value: row.value,
          text: row.text,
        })),
        { value: 'ADD_NEW', text: '+ Add New Category' },
      ];
      setCategorySelectOptions(options);
      setIsLoading(false);
      setIsSuccess(true);
      console.log('Success: Fetched the record.');
    } else {
      console.error('Error: Failed to get record.', result.errorMessages);
      setIsSuccess(false);
      setErrorMessages(result.errorMessages);
    }
  };

  return {
    categorySelectOptions,
    isLoading,
    isSuccess,
    errorMessages,
    loadData,
  };
};
